import { FC, ReactNode } from 'react';
import { useTranslationContext } from '../../contexts/translationContext';
import './loginWrapper.scss';

const LoginWrapper: FC<LoginWrapperProps> = (props: LoginWrapperProps) => {
    const { children, width = '25.43rem', height = '30.75rem' } = props;
    const { translate } = useTranslationContext();

    return (
        <div
            className="form-wrapper-login-wrapper"
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/login.svg))` }}
        >
            <div>
                <img src={`${process.env.PUBLIC_URL}/images/cbLogo.svg`} className="cb-logo" alt="Codebashing Logo" />
                <div className="form-wrapper" style={{ width, height }}>
                    {children}
                </div>
            </div>
            <div className="login-text-wrapper">
                <div>{translate('LearningPanel_WelcomeText')}</div>
                <div className="login-text-subtitle-and-link">
                    <br />
                    <div className="click-here-text">
                        <a href="https://codebashing.com">{translate('ClickHere')}</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface LoginWrapperProps {
    children?: ReactNode;
    width?: string;
    height?: string;
}

export default LoginWrapper;
